import React, {  useState } from 'react';
import login from '../../images/login2.jpg';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
function Registration() {
    const [userInfo, setuserInfo] = useState({
        email: "",
        name: "",
        phone_number: "",
        password: "",
        password_confirmation: "",
        rememberme: false,
        user_type: "customer"
    })
    const [isVissible, setIsVissible] = useState(false);

    const navigate = useNavigate();
    
    const submitRegForm = (e) => {
        e.preventDefault();
        axios.post('/sign-up', userInfo).then(res => {
             navigate('/login')

            Swal.fire({
                position: "top-center",
                icon: "success",
                title: "Success !",
                text: "Successfully registered, you can login in !",
                timer: 2500,
            });

        }).catch(err => {
            Swal.fire({
                position: "top-center",
                icon: "error",
                title: "Error !",
                text: `${err.response.data.message}`,
                timer: 8500,
            });

        })
    }

    return (
        <>

            <section className="h-[90vh] flex flex-col md:flex-row justify-center space-y-10 md:space-y-0 md:space-x-16 items-center my-2 mx-5 md:mx-0 md:my-0">
                <div className="md:w-1/3 max-w-sm">
                    <img
                        src={login}
                        alt="Sample" />
                </div>
                <div className="md:w-1/3 max-w-sm">
                    <h1 className='text-4xl font-bold mb-4'>Register</h1>
                    <input onChange={(e) => setuserInfo({ ...userInfo, name: e.target.value })} className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded" type="text" placeholder="Name" />
                    <input onChange={(e) => setuserInfo({ ...userInfo, email: e.target.value })} className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4" type="email" placeholder="Email Address" />
                    <input onChange={(e) => setuserInfo({ ...userInfo, phone_number: e.target.value })} className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4" type="text" placeholder="Phone Number" />
                    <div className="relative">
                        <input onChange={(e) => setuserInfo({ ...userInfo, password: e.target.value })} className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4" type={isVissible ? "text" : "password"} placeholder="Password" />
                        {
                            isVissible ?
                                <i onClick={() => setIsVissible(!isVissible)} className="cursor-pointer fa-sharp fa-solid fa-eye-slash absolute inset-y-7 right-2"></i>
                                :
                                <i onClick={() => setIsVissible(!isVissible)} className="cursor-pointer fa-solid fa-eye absolute inset-y-7 right-2"></i>
                        }
                    </div>
                    <div className="relative">
                        <input onChange={(e) => setuserInfo({ ...userInfo, password_confirmation: e.target.value })} className="text-sm w-full px-4 py-2 border border-solid border-gray-300 rounded mt-4" type={isVissible ? "text" : "password"} placeholder="Confirm Password" />
                        {
                            isVissible ?
                                <i onClick={() => setIsVissible(!isVissible)} className="cursor-pointer fa-sharp fa-solid fa-eye-slash absolute inset-y-7 right-2"></i>
                                :
                                <i onClick={() => setIsVissible(!isVissible)} className="cursor-pointer fa-solid fa-eye absolute inset-y-7 right-2"></i>
                        }
                    </div>
                    <div className="mt-4 flex justify-between font-semibold text-sm">
                        <div className="text-center md:text-left">
                            <button onClick={submitRegForm} className="bg-blue-600 hover:bg-blue-700 px-4 py-2 text-white uppercase rounded text-xs tracking-wider" type="submit"> Register</button>
                        </div>
                        <a className="text-blue-600 hover:text-blue-700 hover:underline hover:underline-offset-4" href={`${global.back_url}`}>Register as seller</a>
                    </div>

                    <div className="mt-4 font-semibold text-sm text-slate-500 text-center md:text-left">
                        Already have an account? <Link to="/login" className="text-red-600 hover:underline hover:underline-offset-4 cursor-pointer">Login</Link>
                    </div>
                </div>
            </section>
        </>

    );
}

export default Registration;